import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=f892134e&"
import script from "./Node.vue?vue&type=script&lang=js&"
export * from "./Node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f892134e')) {
      api.createRecord('f892134e', component.options)
    } else {
      api.reload('f892134e', component.options)
    }
    module.hot.accept("./Node.vue?vue&type=template&id=f892134e&", function () {
      api.rerender('f892134e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/drag/components/Node.vue"
export default component.exports